import React, { FC, PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

import { WithDataName } from 'common/types'
import { PlainLink } from 'components/presentational/link'

const filterValueCss = css`
  display: inline-block;
  padding: 5px 9px 6px;
  font-size: 15px;
  letter-spacing: -0.3px;
  color: var(--splash-hard);
  border-radius: 4px;
`

/**
 * TODO специально сделали ссылки для полной перезагрузки,
 * так как сходу и быстро не нашлось в чем причина https://redmine.mamba.ru/issues/109375
 */
const FilterValue = styled(PlainLink)`
  ${filterValueCss};
`

const FilterValueSpan = styled.span`
  ${filterValueCss};
  background-color: var(--background-disabled);
  color: var(--static-black);
`

export const SelectedFilter: FC<
  { isSelected: boolean; href: string; id: string } & WithDataName &
    PropsWithChildren
> = ({ isSelected, href, id, children, ...rest }) => {
  if (isSelected) {
    return (
      <FilterValueSpan key={id} data-name={rest['data-name']}>
        {children}
      </FilterValueSpan>
    )
  }

  return (
    <FilterValue href={href} key={id} data-name={rest['data-name']}>
      {children}
    </FilterValue>
  )
}
